import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BlendEvent, FileItem } from 'src/app/shared/models';
import { BatchDeleteService } from 'src/app/shared/services/batch-delete.service';
import { BlendService } from 'src/app/shared/services/blend.service';
import { SkuService } from 'src/app/shared/services/sku.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { IBatchActionView } from 'src/sync';


@Component({
  selector: 'app-dialog-delete',
  templateUrl: './dialog-delete.component.html',
  styleUrls: ['./dialog-delete.component.scss']
})
export class DialogDeleteComponent implements OnInit {

  @Input()
  showDialog: boolean = false;

  @Output()
  showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  deleteSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public selectedItems: FileItem[] = [];

  public deleteItems: FileItem[] = []
  public subTitle: string;

  public batchView: IBatchActionView;
  public purgeLimit: number = 0;

 
  constructor(
    private batchDeleteService: BatchDeleteService,
    private blendService: BlendService,
    private snackbarService: SnackbarService,
    private skuService: SkuService,
  ) { }

  async ngOnInit() {
    this.batchView = this.batchDeleteService.view;
    this.deleteItems = [...this.selectedItems]
    if (this.deleteItems.length === 1) {
      this.subTitle = this.deleteItems[0].name
    } else {
      this.subTitle = this.deleteItems.length + ' items';
    }

    this.purgeLimit = await this.skuService.getDataLimit();
  }

  onDelete = async () => {
    const sync_id_array: number[] = [],
      list = this.deleteItems
        ? this.deleteItems.sort((a, b) => this.sortList(a, b))
        : [];

    for (let i = list.length - 1; i >= 0; i--) {
      sync_id_array.push(list[i].sync_id);
      this.blendService.track(BlendEvent.DELETE_ITEM, {
        size: list[i].size,
        type: list[i].type && list[i].type.toUpperCase() === 'DIR' ? 'folder' : 'file',
        mime_type: list[i].mime_type
      });
    }

    const subject = this.batchDeleteService.execute(sync_id_array);
    subject.complete = () => {
      if (this.deleteItems.length > 1) {
        this.snackbarService.showMessage('success', `${this.deleteItems.length} items have been successfully deleted`);
      } else {
        this.snackbarService.showMessage('success', `'${(this.deleteItems[0].name)}' has been successfully deleted`);
      }
      this.blendService.track(BlendEvent.DELETE_ITEMS, {
        num_items: list.length
      });
      this.deleteSuccess.emit(true);
      this.closeDialog();
      subject.unsubscribe();
    }
    subject.error = () => {
      this.batchView.spinner = 0;
      this.snackbarService.showMessage('critical', `Couldn't complete action. Try again.`);
      this.closeDialog();
    }
  }

  onCancelClick = () => {
    if (this.batchView.spinner !== 0) {
      const c = window.confirm('Are you sure you want to cancel?');
      if (c) {
        this.batchDeleteService.cancel();
        this.closeDialog();
      }
    } else {
      this.closeDialog();
    }
  }

  closeDialog = () => {
    this.showDialog = false
    setTimeout(() => {
      this.showDialogChange.next(false);
    }, 0);
  }

  public sortList(a, b) {
    if (a.type < b.type) {
      return -1;
    } else if (a.type > b.type) {
      return 1;
    } else {
      if (a.search_name < b.search_name) {
        return -1;
      } else if (a.search_name > b.search_name) {
        return 1;
      }
    }
  }

  public isDeletingSharedFolder() {
    return this.deleteItems.some(item => item.is_dir && item.is_shared);
  }


}
